module.exports = __webpack_public_path__ + "img/bg-3.f5b40b1e.png";